import { render, staticRenderFns } from "./materialSample.vue?vue&type=template&id=17d8b982&scoped=true"
import script from "./materialSample.vue?vue&type=script&lang=js"
export * from "./materialSample.vue?vue&type=script&lang=js"
import style0 from "./materialSample.vue?vue&type=style&index=0&id=17d8b982&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d8b982",
  null
  
)

export default component.exports